import { laravelAxios } from '../../../../config/axios/laravelAxios';

async function getUrlViewCrm() {
  const getUrlViewCrm = await laravelAxios.get('crm/getUrl/');
  return getUrlViewCrm;
}
export default getUrlViewCrm;
